import { animated, useTransition } from 'react-spring'
import './Modal.scss'
import ModalContext from './ModalContext'
import { useContext } from 'react'
import classNames from 'classnames'

type ModalBackdropProps = {
  backdropClass?: string
  /** Overrides the backdrop's fully-shown opacity (defaults to 0.8). */
  backdropOpacity?: number
}

const ModalBackdrop: React.FC<ModalBackdropProps> = ({
  backdropClass = '',
  backdropOpacity = 0.8,
}) => {
  const { show } = useContext(ModalContext)

  const backdropTransition = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: backdropOpacity },
    leave: { opacity: 0 },
  })
  return (
    <>
      {backdropTransition((style, item) =>
        item ? (
          <animated.div
            style={style}
            className={classNames('ModalBackdrop', backdropClass)}
          />
        ) : null
      )}
    </>
  )
}

export default ModalBackdrop
